import router from './init';
import './intercept';

export default router;
